{
  " · {n} 位参与者": " · {n} attendees",
  " · 第一次": " · first occurrence",
  " · 即时推送": " · instant push",
  " · 文件共 {size}": " · {size} on disk",
  " 服务器还需要配置 MOMOMAIL_PUBLIC_URL。": " The server also needs MOMOMAIL_PUBLIC_URL configured.",
  " 现在用的是 {user} 的 {email}。": " Currently using {email} belonging to {user}.",
  "，抄送 {names}": ", cc {names}",
  "，已更新 Google 日历": ", Google Calendar updated",
  "，已加入 Google 日历": ", added to Google Calendar",
  "。以后可以重新添加。": ". You can add it again later.",
  "。这一步不能撤销。": ". This can’t be undone.",
  "\"忘记密码\"的重置邮件从这个邮箱发出。只能选你自己名下的邮箱账户。": "Password reset emails are sent from this account. You can only choose one of your own email accounts.",
  "\"在 Google 日历中打开\"会打开填好的新建页面，点保存就行；也可以下载 .ics 导入别的日历。": "\"Open in Google Calendar\" opens a pre-filled new event — just click Save. You can also download an .ics file for other calendars.",
  "（比如 https://mail.example.com），才能发重置邮件、生成邀请链接。": " (e.g. https://mail.example.com) before it can send reset emails or create invitation links.",
  "（留空不修改）": " (leave blank to keep)",
  "（你）": " (you)",
  "(未知)": "(unknown)",
  "(无)": "(none)",
  "（无标题）": "(Untitled)",
  "（无标题的活动）": "(Untitled event)",
  "(无收件人)": "(no recipients)",
  "(无主题)": "(no subject)",
  "（邀请里的时区：{zone}）": " (time zone in the invitation: {zone})",
  "（这封邮件没有正文）": "(This message has no body)",
  "{ago}登录": "signed in {ago}",
  "{done}，回复已发给组织者{cal}": "{done}; reply sent to the organizer{cal}",
  "{email} 的\"{folder}\"": "“{folder}” in {email}",
  "{email} 已登录，正在收信…": "{email} signed in, fetching mail…",
  "{label}（{hint}）": "{label} ({hint})",
  "{label}（至少 8 位）": "{label} (at least 8 characters)",
  "{n} 分钟前": "{n} min ago",
  "{n} 封": "{n} messages",
  "{n} 封未读": "{n} unread",
  "{n} 个附件": "{n} attachments",
  "{n} 个邮箱账户": "{n} email account(s)",
  "{n} 个账户": "{n} accounts",
  "{n} 个账户的收件箱": "the inboxes of {n} accounts",
  "{n} 年": "{n} year(s)",
  "{n} 天": "{n} days",
  "{n} 小时前": "{n} h ago",
  "{name} 的邮件": "Message from {name}",
  "{name} 的重置密码链接": "Password reset link for {name}",
  "{name} 现在是管理员": "{name} is now an admin",
  "{range}（全天）": "{range} (all day)",
  "{time} 前有效，还没人用": "Valid until {time}, not used yet",
  "{time} 前有效，只能用一次。这个链接只显示这一次，关掉后就看不到了。": "Valid until {time} and works only once. This link is shown only now — you won’t see it again after closing.",
  "{where} API Key": "API key {where}",
  "{where}登录": "Sign-in {where}",
  "{where}里的所有邮件都会标为已读，包括还没下载到馍馍邮箱的老邮件。Gmail 等邮箱里也会同时变成已读，没法一键撤销。": "All mail in {where} will be marked as read, including older mail not yet downloaded to Momomail. It will also become read in Gmail and other providers, and can’t be undone in one click.",
  "{where}没有装这个 AI": "This AI isn’t installed {where}",
  "1 封": "1 message",
  "1 个附件": "1 attachment",
  "1 个账户": "1 account",
  "1 个账户的收件箱": "the inbox of 1 account",
  "1 小时": "1 hour",
  "1. 打开授权网页，用你的 {name} 账号登录并同意。": "1. Open the authorization page, sign in with your {name} account and approve.",
  "2–32 个字符：字母、数字、汉字、. _ -": "2–32 characters: letters, digits, Chinese characters, . _ -",
  "2. 授权后页面上会显示一段代码，复制贴到这里": "2. After approving, the page shows a code — copy and paste it here",
  "2. 输入授权码并同意后，这里会自动完成。": "2. Once you enter the code and approve, this finishes automatically.",
  "安全连接没能建立": "Couldn't establish a secure connection",
  "把几个邮箱放在一起收：工作的、个人的，一个窗口全看见。": "All your mailboxes in one place — work and personal, in a single window. ",
  "把馍馍邮箱服务器部署在自己的服务器上（见 README），这里填地址和管理员给你开的用户名、密码。连接后这台电脑上的本机邮件服务会停下，本机数据保留，随时可以改回来。": "Deploy the Momomail server on your own machine (see the README), then enter its address and the username and password your admin gave you. Once connected, the local mail service on this computer stops; local data is kept and you can switch back anytime.",
  "把应用更新到最新版，或者请管理员更新服务器。": "Update the app to the latest version, or ask your admin to update the server.",
  "把这个链接发给{name}。对方打开后自己设用户名、密码和找回邮箱，你看不到他的密码。": "Send this link to {name}. They’ll set their own username, password and recovery email when they open it — you won’t see their password.",
  "把这个链接发给对方。对方打开后自己设用户名、密码和找回邮箱，你看不到他的密码。": "Send this link to the person you’re inviting. They’ll set their own username, password and recovery email — you won’t see their password.",
  "把这个链接交给 {name}，他打开后自己设新密码——你看不到新密码。设好后他所有设备上的登录都会退出。": "Give this link to {name} to set a new password themselves — you won’t see it. Once set, they’ll be signed out on all their devices.",
  "包括还没下载的老邮件": "Including older mail not downloaded yet",
  "保存": "Save",
  "保存 {name}": "Save {name}",
  "保存并选择": "Save and select",
  "保存草稿": "Save draft",
  "保存到 Google 日历（{email}）": "Save to Google Calendar ({email})",
  "保存这封草稿吗？": "Save this draft?",
  "保存中…": "Saving…",
  "保留多久": "Keep for",
  "保留多久的邮件列表": "Keep message lists for",
  "备注": "Note",
  "备注（可以不填，比如：妈妈）": "Note (optional, e.g. Mom)",
  "本地缓存上限": "Local cache limit",
  "本机": "on this computer",
  "本机的邮件服务还没响应。": "The local mail service isn’t responding yet.",
  "本机邮件服务断开了，正在重新连接…": "The local mail service disconnected. Reconnecting…",
  "比如：工作、个人": "e.g. Work, Personal",
  "比如：用一句话介绍你自己": "e.g. Introduce yourself in one sentence",
  "编辑": "Edit",
  "编辑 {email}": "Edit {email}",
  "标题": "Title",
  "标为垃圾邮件": "Mark as spam",
  "标为未读": "Mark as unread",
  "标为已读": "Mark as read",
  "标为已读 / 未读": "Mark read / unread",
  "不保存": "Don’t save",
  "不保存的话，写的内容会丢掉。": "If you don’t save it, what you wrote will be lost.",
  "不缓存": "No cache",
  "不加密": "None",
  "不加密时密码会明文经过网络，只建议用于本机测试服务器。": "Without encryption your password travels the network in plain text. Only use this for a local test server.",
  "不设置": "None",
  "不预下载": "Don’t prefetch",
  "部分账户不支持推送，定时检查新邮件": "Some accounts don’t support push; checking for new mail periodically",
  "草稿": "Draft",
  "草稿箱": "Drafts",
  "草稿已保存": "Draft saved",
  "草稿已存在本地，上传到服务器失败：{error}": "Draft saved on this device, but uploading it to the server failed: {error}",
  "测试并添加": "Test and add",
  "测试连接": "Test connection",
  "抄送": "Cc",
  "抄送 / 密送": "Cc / Bcc",
  "超过时，最久没打开的邮件先删掉正文（列表和摘要还在，打开时重新下载）。": "When over the limit, bodies of the least recently opened messages are removed first (lists and previews stay; they’re downloaded again when opened).",
  "超过时最久没看的先删（再打开时从服务器取）。": "When over the limit, the least recently viewed are removed first (fetched from the server again when opened).",
  "彻底删除": "Delete forever",
  "撤销": "Revoke",
  "窗口收进托盘时也会提醒。点通知直接打开那封邮件。": "Works even when the window is in the tray. Click a notification to open that message.",
  "创建账号并登录": "Create account and sign in",
  "从这封邮件建一个日程": "Create an event from this message",
  "从左边选一封邮件来读。": "Pick a message on the left to read it.",
  "存草稿": "Save draft",
  "存草稿（写信时）": "Save draft (while composing)",
  "存草稿（Ctrl+S）": "Save draft (Ctrl+S)",
  "存储": "Storage",
  "存的草稿会出现在这里。": "Saved drafts show up here.",
  "打不开邀请": "Can’t open the invitation",
  "打开": "Open",
  "打开 {name}": "Open {name}",
  "打开 Google 登录页": "Open Google sign-in page",
  "打开\"获取 API Key\"，创建一个 Key，复制后粘贴到这里。保存前会先用它连一次，确认能用。": "Open \"Get an API key\", create a key, then copy and paste it here. It is tested once before saving to make sure it works.",
  "打开过的 {n} 封占 {size}": "{n} opened messages use {size}",
  "打开过的邮件最多占": "Opened messages may use up to",
  "打开授权网页 ↗": "Open authorization page ↗",
  "当前版本 {version}": "Current version {version}",
  "当前列表全部标为已读": "Mark everything in this list as read",
  "当前密码": "Current password",
  "到明早": "Until tomorrow morning",
  "地点": "Location",
  "登出": "Sign out",
  "登录": "Sign in",
  "登录 Windows 后在托盘里悄悄启动，开始收信。（只对这台电脑生效）": "Start quietly in the tray after you sign in to Windows and begin checking mail. (This computer only)",
  "登录{who}并点\"允许\"，完成后这里会自动继续。": " sign in to {who} and click \"Allow\" — this continues automatically when you’re done.",
  "登录并切换": "Sign in and switch",
  "登录方式": "Sign-in method",
  "登录馍馍邮箱服务器": "Sign in to your Momomail server",
  "登录失败（{status}）": "Sign-in failed ({status})",
  "登录失效，收不到新邮件": "sign-in expired, can’t receive new mail",
  "登录失效：{error}": "Sign-in expired: {error}",
  "登录已失效，请重新登录": "Your session expired. Please sign in again.",
  "等待 Google 授权…": "Waiting for Google authorization…",
  "等待连接": "Waiting to connect",
  "等待连接…": "Waiting to connect…",
  "等几分钟再试。": "Wait a few minutes and try again.",
  "等了 30 分钟还没完成，请重新开始。": "Still not done after 30 minutes. Please start over.",
  "等你在网页上完成授权…": "Waiting for you to finish authorizing on the web…",
  "点 × 会把窗口收进托盘，继续收信和提醒。要彻底退出，请右键托盘图标选择退出。": "Clicking × hides the window to the tray, where mail and notifications keep working. To quit completely, right-click the tray icon and choose Quit.",
  "丢弃": "Discard",
  "丢弃这封邮件？": "Discard this message?",
  "都标成已读了": "All marked as read",
  "都读完啦": "All caught up",
  "端口": "Port",
  "断开": "Disconnect",
  "断开 {email} 的 Google 日历？": "Disconnect the Google Calendar of {email}?",
  "对方看到的名字": "The name recipients see",
  "发给": "To",
  "发件人": "From",
  "发件人、主题和摘要": "Sender, subject and preview",
  "发件人和主题": "Sender and subject",
  "发送": "Send",
  "发送（写信时）": "Send (while composing)",
  "发送失败": "Sending failed",
  "发送中…": "Sending…",
  "发送重置邮件": "Send reset email",
  "发信（SMTP）": "Outgoing (SMTP)",
  "发信（SMTP）：": "Outgoing (SMTP): ",
  "发信时显示的名字": "Name shown when sending",
  "返回": "Back",
  "服务器": "Server",
  "服务器出错了": "The server ran into an error",
  "服务器地址": "Server address",
  "服务器地址不对": "That server address isn't valid",
  "服务器的 HTTPS 证书有问题，或者网络里的代理 / VPN 在干扰加密连接。换个网络试试，或者联系管理员。": "The server's HTTPS certificate has a problem, or a proxy / VPN on your network is interfering with the encrypted connection. Try another network, or contact the admin.",
  "服务器还需要配置": "The server still needs",
  "服务器没有回应": "The server is not responding",
  "服务器没有配置 Google 登录，所以不能直接写 Google 日历（请管理员按 deploy/README.md 配置）。\"加入日历\"照样能用：它会打开填好的 Google 日历新建页面，或者下载 .ics 文件导入别的日历。": "The server has no Google sign-in configured, so it can’t write to Google Calendar directly (ask your admin to set it up per deploy/README.md). \"Add to calendar\" still works: it opens a pre-filled Google Calendar event, or downloads an .ics file for other calendars.",
  "服务器上": "on the server",
  "服务器上的缓存": "Cache on the server",
  "服务器上的缓存清空了": "Server cache cleared",
  "服务器上的邮件不受影响": "mail on the server is not affected",
  "服务器上的邮件都标成已读了": "All mail on the server is marked as read",
  "服务器上全部标为已读？": "Mark everything read on the server?",
  "服务器上全部已读": "Mark all read on the server",
  "服务器上已经下载好的邮件正文会删掉（邮箱里的邮件不受影响），之后打开时再从邮箱重新下载。": "Message bodies already downloaded to the server will be deleted (mail in your mailbox is not affected) and downloaded again when you open them.",
  "服务器设置": "Server settings",
  "服务器在后台把这段时间的邮件正文先下好（未读的优先），打开就是秒开。缓存快满时会停下。": "The server downloads message bodies from this period in the background (unread first) so they open instantly. Stops when the cache is nearly full.",
  "服务器支持推送（IDLE），新邮件会即时到达": "Server supports push (IDLE); new mail arrives instantly",
  "附件": "Attach",
  "附件加起来超过 25 MB，很多邮箱会拒收。": "Attachments add up to more than 25 MB; many mail servers will reject this.",
  "复制回调地址": "Copy redirect URI",
  "复制链接": "Copy link",
  "复制链接，在别的设备上打开": "Copy the link to open it on another device",
  "复制失败，请手动选中复制": "Couldn’t copy. Please select and copy it manually",
  "复制失败，请手动选中链接复制": "Couldn’t copy. Please select the link and copy it manually",
  "复制授权码": "Copy code",
  "改好以后，其他设备（包括手机 App）上的登录都会退出，这台设备保持登录。": "After changing it, you’ll be signed out on other devices (including the phone app); this device stays signed in.",
  "改回本机": "Switch to local",
  "改回本机模式": "Switch back to local mode",
  "刚刚": "Just now",
  "高级设置": "Advanced",
  "跟随系统": "Follow system",
  "跟随系统：按系统的语言选，没有这种语言时用英文。手机和电脑同步。想加一种语言？见仓库的 locales/README.md。": "Follow system: use the system language, or English if it isn't available. Synced between phone and computer. Want to add a language? See locales/README.md in the repository.",
  "更多已读选项": "More mark-as-read options",
  "更早的邮件翻到时再问服务器。改长了要从服务器补齐。": "Older mail is fetched from the server when you scroll to it. Increasing this downloads the missing part from the server.",
  "关闭": "Close",
  "关闭（收进托盘，继续收信）": "Close (minimize to tray, keep receiving mail)",
  "关闭（收进托盘）": "Close (minimize to tray)",
  "关闭（Esc）": "Close (Esc)",
  "关闭窗口": "Closing the window",
  "关掉": "Dismiss",
  "关掉窗口它会待在托盘里，新邮件照样提醒你。": "Close the window and it stays in the tray, still notifying you of new mail.",
  "官方 API 地址": "Official API endpoint",
  "管理员": "Admin",
  "管理员邀请链接": "Admin invitation link",
  "归档": "Archive",
  "还没登录过": "never signed in",
  "还没同步过": "Not synced yet",
  "还没有账户。": "No accounts yet.",
  "还没准备好": "Not ready yet",
  "还有 {n} 封没读": "{n} unread to go",
  "还原": "Restore",
  "和邮件服务器的连接断了，正在重新连接…": "Lost connection to the mail server. Reconnecting…",
  "欢迎使用馍馍邮箱": "Welcome to Momomail",
  "缓存上限": "Cache limit",
  "换个服务商": "Choose another provider",
  "换回「全部」看看。": "Switch back to “All” to see everything.",
  "换一个 API Key": "Change API key",
  "恢复": "Re-enable",
  "恢复通知": "Resume notifications",
  "回到登录": "Back to sign-in",
  "回复": "Reply",
  "回复邀请": "Respond to invitation",
  "回复这封": "Reply to this message",
  "回去写主题": "Add a subject",
  "会话视图": "Conversation view",
  "会议邀请": "Meeting invitation",
  "获取 API Key ↗": "Get an API key ↗",
  "即时": "Live",
  "继续编辑": "Keep editing",
  "继续写": "Keep writing",
  "继续写草稿": "Continue draft",
  "加 / 取消星标": "Star / unstar",
  "加密": "Security",
  "加入馍馍邮箱": "Join Momomail",
  "加入馍馍邮箱（管理员）": "Join Momomail (admin)",
  "加入日历": "Add to calendar",
  "加星标": "Star",
  "加星标（S）": "Star (S)",
  "加载更早的邮件…": "Loading older mail…",
  "加载中": "Loading",
  "检测到{where}的 API Key（{source}）": "Found an API key {where} ({source})",
  "检测到{where}已登录": "Found a sign-in {where}",
  "检查地址和网络；服务器可能没在运行，或者被防火墙、代理挡住了。": "Check the address and your network; the server may be down, or blocked by a firewall or proxy.",
  "检查地址有没有拼错；域名如果是刚设置的，可能还没生效。": "Check the address for typos; a domain that was just set up may not be live yet.",
  "检查更新": "Check for updates",
  "检查更新失败：{error}": "Update check failed: {error}",
  "检查新邮件的间隔": "Check for new mail every",
  "键盘快捷键": "Keyboard shortcuts",
  "接受": "Accept",
  "结束": "End",
  "结束日期": "End date",
  "结束日期不能早于开始日期": "The end date can’t be before the start date",
  "结束时间不能早于开始时间": "The end time can’t be before the start time",
  "截止": "Due",
  "拒绝": "Decline",
  "开发版不自动更新。": "Development builds do not update automatically.",
  "开会、专注时先别打扰。托盘右键菜单里也能暂停。": "For meetings and focus time. You can also pause from the tray menu.",
  "开机启动": "Start at login",
  "开机时自动启动": "Start at login",
  "开始": "Start",
  "开始日期": "Start date",
  "可以不填": "Optional",
  "快捷键": "Shortcuts",
  "垃圾邮件": "Spam",
  "离线，稍后自动重连": "Offline, will reconnect soon",
  "立即收信": "Check mail now",
  "立即收信（F5）": "Check mail now (F5)",
  "连不上 {url}。": "Can’t reach {url}.",
  "连不上服务器": "Can't reach the server",
  "连不上邮件服务": "Can’t reach the mail service",
  "连不上邮件服务，请检查网络": "Can’t reach the mail service. Check your network.",
  "连接 Google 日历": "Connect Google Calendar",
  "连接成功": "Connected",
  "连接远程服务器": "Connect to a remote server",
  "连接正常 · {ago}同步": "Connected · synced {ago}",
  "连上网络后再试。": "Connect to the internet and try again.",
  "连远程服务器时，这台电脑也存一份最近的邮件列表和打开过的邮件：启动和翻页不用等网络，断网时也能看。": "When connected to a remote server, this computer also keeps recent message lists and opened messages, so starting up and scrolling don’t wait on the network — and you can read offline.",
  "链接": "Link",
  "链接已复制": "Link copied",
  "两次输入的密码不一样": "The passwords don’t match",
  "列表里的全部已读": "Mark all in this list as read",
  "列表里的邮件全部标为已读（Shift+I）": "Mark everything in this list as read (Shift+I)",
  "另存为…": "Save as…",
  "另外网页登录一个账号": "Sign in with another account",
  "浏览器显示\"无法访问\"时，把地址栏里的网址粘贴到这里": "If the browser says the page can’t be reached, paste the URL from the address bar here",
  "没能完成": "That didn't work",
  "没认出时间，请手动选。": "No time found — please pick one.",
  "没有配置：Gmail 只能用应用专用密码，\"加入日历\"只能打开 Google 日历网页或下载 .ics。配置方法见 deploy/README.md（Google Cloud 建一个 OAuth 客户端，填 MOMOMAIL_GOOGLE_CLIENT_ID / SECRET）。": "Not configured: Gmail can only use app passwords, and \"Add to calendar\" can only open Google Calendar on the web or download an .ics file. See deploy/README.md for setup (create an OAuth client in Google Cloud and set MOMOMAIL_GOOGLE_CLIENT_ID / SECRET).",
  "没有未读": "No unread",
  "没有未读邮件": "No unread mail",
  "没有星标邮件": "No starred mail",
  "没有邮件包含\"{query}\"。试试换个词，或者少输几个字。": "No mail contains “{query}”. Try a different word, or fewer letters.",
  "没有找回邮箱": "no recovery email",
  "没有主题": "No subject",
  "没找到": "Nothing found",
  "每 {m} 分钟": "Every {m} minutes",
  "密码": "Password",
  "密码 / 应用密码": "Password / app password",
  "密码改好了": "Password changed",
  "密码加密保存在你的馍馍邮箱服务器上，邮件也存在那里。": "Passwords are stored encrypted on your Momomail server, and your mail is stored there too.",
  "密码加密保存在这台电脑上（密钥由系统保护），邮件也只缓存在本机。": "Passwords are stored encrypted on this computer (the key is protected by the OS), and mail is cached only on this machine.",
  "密码输错太多次了": "Too many wrong passwords",
  "密码已修改，其他设备上的登录已经退出": "Password changed. You’ve been signed out on other devices",
  "密码只加密保存在后端（本机或你的服务器），不会发给别处。也可以在服务器上用命令行": "Passwords are stored encrypted on the backend only (this computer or your server) and are never sent anywhere else. You can also add accounts on the server with",
  "密码至少 8 个字符": "Password must be at least 8 characters",
  "密送": "Bcc",
  "馍馍猫抱着一封信": "Momo the cat holding a letter",
  "馍馍邮箱": "Momomail",
  "馍馍邮箱菜单": "Momomail menu",
  "模型": "Model",
  "默认": "Default",
  "默认（{size}）": "Default ({size})",
  "那封邮件已经不在了": "That message no longer exists",
  "你的 Google 账号": "your Google account",
  "你还没有邮箱账户：先在\"账户\"里加一个，才能选它当系统发信邮箱。": "You have no email accounts yet. Add one under \"Accounts\" to use it as the system sender.",
  "你已回复暂定": "You replied maybe",
  "你已接受": "You accepted",
  "你已拒绝": "You declined",
  "配色主题": "Theme",
  "普通用户": "Regular user",
  "其他 IMAP 邮箱": "Other IMAP mail",
  "启动后会自动检查，每 6 小时一次；新版本在后台下载，下好了提示你重启。": "Checks on startup and every 6 hours; new versions download in the background and you'll be asked to restart when ready.",
  "签名": "Signature",
  "浅色": "Light",
  "清除搜索": "Clear search",
  "清除搜索 / 关闭对话框": "Clear search / close dialog",
  "清空": "Clear",
  "清空并重新同步": "Clear and resync",
  "清空服务器缓存": "Clear server cache",
  "清空服务器上的缓存？": "Clear the cache on the server?",
  "清空这台电脑上的副本？": "Clear the copy on this computer?",
  "请管理员在服务器上运行 account reauth": "Ask your admin to run “account reauth” on the server",
  "请联系管理员。": "Please contact your admin.",
  "请求失败（{status}）": "Request failed ({status})",
  "请填写{what}": "Please enter your {what}",
  "请填写标题": "Please enter a title",
  "请填写邮箱地址": "Please enter an email address",
  "请至少填一个收件人。": "Add at least one recipient.",
  "取消": "Cancel",
  "取消登录": "Cancel sign-in",
  "取消管理员": "Remove admin",
  "取消星标": "Unstar",
  "取消星标（S）": "Unstar (S)",
  "去登录": "Go to sign-in",
  "去邮箱看看": "Check your email",
  "全部": "All",
  "全部标为已读": "Mark all as read",
  "全部回复": "Reply all",
  "全部快捷键": "all shortcuts",
  "全部收件箱": "All inboxes",
  "全部已读": "Mark all read",
  "全天": "All day",
  "确认填的是管理员给你的服务器地址，不是落地页或别的网站。": "Make sure it's the server address your admin gave you, not the landing page or another site.",
  "仍然保存": "Save anyway",
  "仍然发送": "Send anyway",
  "日历": "Calendar",
  "如果信息匹配，重置邮件已经发出，30 分钟内有效。没收到的话看看垃圾邮件，或者找管理员要一个重置链接。": "If the details match, a reset email has been sent; it’s valid for 30 minutes. If it doesn’t arrive, check your spam folder or ask your admin for a reset link.",
  "如何获取？↗": "How? ↗",
  "筛选": "Filter",
  "删除": "Delete",
  "删除 API Key": "Delete API key",
  "删除用户": "Delete user",
  "删除用户 {name}": "Delete user {name}",
  "删除用户\"{name}\"？": "Delete user \"{name}\"?",
  "删除账户": "Remove account",
  "删除账户 {email}": "Remove account {email}",
  "删除账户\"{name}\"？": "Remove account \"{name}\"?",
  "删掉的邮件会放在这里。": "Deleted mail goes here.",
  "上次检查更新没成功，稍后会自动再试。": "The last update check didn't succeed; it will try again later.",
  "上次同步 {time}": "Last synced {time}",
  "上下切换": "next / previous",
  "上一封": "Previous message",
  "稍后再试；一直这样请联系管理员。": "Try again later; if it keeps happening, contact your admin.",
  "设为管理员": "Make admin",
  "设置": "Settings",
  "设置你自己的用户名和密码，管理员看不到你的密码。邀请 {time} 前有效，只能用一次。": "Choose your own username and password — your admin can’t see your password. This invitation is valid until {time} and works only once.",
  "设置你自己的用户名和密码，管理员看不到你的密码。邀请只能用一次。": "Choose your own username and password — your admin can’t see your password. This invitation works only once.",
  "设置新密码": "Set new password",
  "深色": "Dark",
  "生成邀请链接": "Create invitation link",
  "生成一个一次性链接（7 天有效）发给对方，对方自己设用户名、密码和找回邮箱。服务器不开放注册。": "Create a one-time link (valid for 7 days) and send it to them; they’ll set their own username, password and recovery email. The server has no open sign-up.",
  "生成重置密码链接": "Create a password reset link",
  "时间": "Date",
  "试一试": "Try it",
  "收件人": "To",
  "收件箱": "Inbox",
  "收件箱是空的": "Your inbox is empty",
  "收进托盘": "Minimize to tray",
  "收起": "Collapse",
  "收起原文": "Hide original",
  "收信（IMAP）": "Incoming (IMAP)",
  "收信（IMAP）：": "Incoming (IMAP): ",
  "手动填写收信（IMAP）和发信（SMTP）服务器。服务器地址一般在邮箱网页版的设置或帮助里能找到。": "Enter the incoming (IMAP) and outgoing (SMTP) servers yourself. You can usually find them in your mail provider’s web settings or help pages.",
  "手机推送内容": "Phone push content",
  "授权码": "authorization code",
  "授权失败": "Authorization failed",
  "输入 API Key": "Enter API key",
  "输入用户名或找回邮箱，我们会往你的找回邮箱发一个重置链接。": "Enter your username or recovery email and we’ll send a reset link to your recovery email.",
  "说明": "Description",
  "松手添加附件": "Drop to attach",
  "搜索": "Search",
  "搜索结果": "Search results",
  "搜索邮件": "Search mail",
  "搜索主题、联系人、正文…": "Search subject, people, body…",
  "所有账户": "All accounts",
  "他的 {n} 个邮箱账户、邮件缓存、手机推送登记会全部删掉，并退出所有设备。": "Their {n} email account(s), mail cache and phone push registrations will all be deleted, and they’ll be signed out everywhere. ",
  "他会退出所有设备、登不上，服务器也停止替他收信。数据都留着，随时可以恢复。": "They’ll be signed out everywhere and unable to sign in, and the server stops fetching their mail. Their data is kept and you can re-enable them anytime.",
  "它是别人电脑上的本机模式；请连部署在服务器上的馍馍邮箱。": "It's someone's desktop running in local mode; connect to a Momomail server deployed on a server instead.",
  "腾出服务器空间，或者邮件显示不对时重新下载。": "Free up server space, or redownload when messages display incorrectly.",
  "提交": "Submit",
  "提前下载": "Prefetch",
  "提示音": "Sound",
  "添加 {provider} 账户": "Add {provider} account",
  "添加账户": "Add account",
  "添加账户，Gmail 支持 OAuth 授权。": "; Gmail supports OAuth.",
  "添加账户：选一个邮箱服务商": "Add account: choose an email provider",
  "填完整的地址，比如 https://mail.example.com；远程服务器要用 https://。": "Enter the full address, like https://mail.example.com; remote servers must use https://.",
  "填写 {provider} 账户": "Set up your {provider} account",
  "填写的 API Key": "Entered API key",
  "停用": "Disable",
  "停用\"{name}\"？": "Disable \"{name}\"?",
  "停止使用{source}": "Stop using {source}",
  "通用": "General",
  "通知": "Notifications",
  "通知时播放系统提示音。": "Play the system sound with notifications.",
  "同步失败：{error}": "Sync failed: {error}",
  "同一个话题的往来邮件合成一条，打开时按时间排在一起。": "Group messages on the same topic into one item, shown in time order when opened.",
  "推送会经过 ntfy 或 Google，可以少带一点内容。": "Push goes through ntfy or Google, so you may want to include less.",
  "退出并安装新版本，装完会自动重新打开": "Quit and install the new version; it reopens when done",
  "退出登录": "Sign out",
  "退出登录？": "Sign out?",
  "退出馍馍邮箱": "Quit Momomail",
  "外观": "Appearance",
  "完成": "Done",
  "网络可能很慢或者服务器太忙，稍后再试。": "The network may be slow or the server busy — try again in a moment.",
  "网页登录": "Sign in on the web",
  "网页登录需要 Kimi Code 套餐（Plus 或以上）。": "Web sign-in requires a Kimi Code plan (Plus or higher).",
  "网易 163 邮箱": "NetEase 163 Mail",
  "忘记密码": "Forgot password",
  "忘记密码？": "Forgot password?",
  "忘记密码请联系管理员": "Forgot your password? Contact your admin",
  "忘了密码时，重置链接会发到这里。请填一个你平时能收到信的邮箱。": "If you forget your password, the reset link is sent here. Use an address you actually check.",
  "微软已逐步关闭密码登录（基本身份验证），很多账户只能用 OAuth 登录，这个版本还不支持。如果你的组织仍允许 IMAP 密码登录，可以先试试。": "Microsoft is phasing out password sign-in (Basic Authentication); many accounts can only use OAuth, which this version doesn’t support yet. If your organization still allows IMAP password sign-in, give it a try.",
  "为了保护隐私，已拦下远程图片（它们可能用来追踪你是否读过邮件）。": "Remote images were blocked to protect your privacy (they can be used to track whether you read the message).",
  "未备注的邀请": "Invitation without a note",
  "未读": "Unread",
  "未连接 · 先填写 API Key": "Not connected · enter an API key",
  "未连接 · 先网页登录或填写 API Key": "Not connected · sign in on the web or enter an API key",
  "未配置": "Not configured",
  "位置": "Folder",
  "我": "me",
  "系统发信邮箱": "System sender",
  "下一封": "Next message",
  "下载 .ics": "Download .ics",
  "下载失败（{status}）": "Download failed ({status})",
  "先把正在写的这封处理完": "Finish the message you’re writing first",
  "先把正在写的这封发出去或者存成草稿": "Send or save the message you’re writing first",
  "先设置系统发信邮箱，新用户忘了密码才能自己找回。": "Set a system sender first so new users can reset forgotten passwords themselves.",
  "先添加一个邮箱": "Add a mailbox first",
  "先添加一个邮箱账户": "Add an email account first",
  "显示快捷键": "Show shortcuts",
  "显示图片": "Show images",
  "显示引用的原文": "Show quoted text",
  "显示转发的原文": "Show forwarded message",
  "现在重试": "Retry now",
  "详情": "Details",
  "想说点什么…": "Write something…",
  "写的内容和已保存的草稿都会删掉。": "What you wrote and any saved draft will be deleted.",
  "写个主题": "Subject",
  "写信时自动加在末尾（可以不填）": "Added to the end of new messages (optional)",
  "写邮件": "Compose",
  "写邮件（C）": "Compose (C)",
  "新版本 {version} 已经下载好了。": "Version {version} has been downloaded.",
  "新版本 {version} 已下载，重启更新": "Version {version} is ready — restart to update",
  "新密码": "New password",
  "新邮件时发系统通知": "Show a system notification for new mail",
  "新邮件通知": "New mail notifications",
  "星标": "Starred",
  "星标邮件": "Starred",
  "修改密码": "Change password",
  "需要登录": "Sign-in required",
  "需要先开启两步验证，再在 Google 账号里生成\"应用专用密码\"（16 位）。普通登录密码不能用。": "Turn on 2-Step Verification first, then create an \"App password\" (16 characters) in your Google Account. Your normal password won’t work.",
  "选一个 AI 给馍馍邮箱用（以后的分类、摘要、起草回复、日历都用它）。点卡片选用；灰色卡片要先网页登录（用你已有的套餐）或填 API Key。登录和 Key 只属于你自己，别的用户看不到。": "Choose an AI for Momomail (used for sorting, summaries, drafting replies and calendar). Click a card to select it; grayed-out cards need a web sign-in (using a subscription you already have) or an API key first. Your sign-ins and keys belong to you only — other users can’t see them.",
  "选择 {name}": "Select {name}",
  "选择这张卡片，就是同意使用{where}已有的凭证（{source}）。会复制一份给你用，原来的登录不受影响。": "Selecting this card means you agree to use the existing credentials {where} ({source}). A copy is made for you; the original sign-in is not affected.",
  "颜色": "Color",
  "邀请": "Invitation",
  "邀请链接": "Invitation link",
  "邀请链接无效、已经用过或者过期了，也可能服务器还没准备好接收新用户。请找管理员重新要一个。": "The invitation link is invalid, already used or expired — or the server isn’t ready for new users yet. Please ask your admin for a new one.",
  "邀请新用户": "Invite a new user",
  "页面要求输入授权码时填：": "When the page asks for a code, enter:",
  "一直": "Indefinitely",
  "移除 {address}": "Remove {address}",
  "移除附件 {name}": "Remove attachment {name}",
  "移动到": "Move to",
  "移动到…": "Move to…",
  "移动到…（V）": "Move to… (V)",
  "已保存 {name}": "Saved {name}",
  "已保存 API Key": "API key saved",
  "已保存{where}的 API Key": "Saved the API key {where}",
  "已保存到 {calendar} 的 Google 日历。": "Saved to the Google Calendar of {calendar}.",
  "已彻底删除": "Deleted forever",
  "已撤销邀请": "Invitation revoked",
  "已断开": "Disconnected",
  "已发送": "Sent",
  "已复制": "Copied",
  "已复制链接": "Link copied",
  "已归档": "Archived",
  "已恢复 {name}": "Re-enabled {name}",
  "已回复暂定": "Replied maybe",
  "已加入 {calendar} 的 Google 日历": "Added to the Google Calendar of {calendar}",
  "已接受": "Accepted",
  "已经是最新版本。": "You have the latest version.",
  "已经下载到馍馍邮箱的邮件": "Mail already downloaded to Momomail",
  "已拒绝": "Declined",
  "已连接": "Connected",
  "已连接 {email} 的 Google 日历": "Connected the Google Calendar of {email}",
  "已配置：用户可以用 Google 登录 Gmail、连接 Google 日历。Google Cloud 的 OAuth 客户端里要登记这个回调地址：": "Configured: users can sign in to Gmail with Google and connect Google Calendar. Register this redirect URI in your Google Cloud OAuth client:",
  "已取消 {name} 的管理员": "{name} is no longer an admin",
  "已取消系统发信邮箱": "System sender removed",
  "已删除": "Trash",
  "已删除 {name}": "Deleted {name}",
  "已设置系统发信邮箱": "System sender set",
  "已是最新 · {ago}": "Up to date · {ago}",
  "已添加 {email}，正在收信…": "Added {email}, fetching mail…",
  "已停用": "Disabled",
  "已停用 {name}": "Disabled {name}",
  "已退出登录": "Signed out",
  "已网页登录（套餐）": "Signed in on the web (subscription)",
  "已下载 {done} / {total} 封": "{done} / {total} messages downloaded",
  "已选择": "Selected",
  "已移除 {email}": "Removed {email}",
  "已移到垃圾邮件": "Moved to Spam",
  "已移动": "Moved",
  "已用空间": "Space used",
  "已在浏览器里打开 Google 登录页。": "The Google sign-in page is open in your browser.",
  "已暂停，直到你恢复": "Paused until you resume",
  "已暂停到 {time}": "Paused until {time}",
  "应用和服务器的版本不兼容": "The app and the server versions aren't compatible",
  "应用专用密码": "App password",
  "应用专用密码（推荐，最稳定）": "App password (recommended, most reliable)",
  "应用专用密码一次设置、长期有效，不受 Google 授权变动影响。学校、公司的账号可能不支持。": "An app password is set up once and keeps working, unaffected by changes to Google access. School and work accounts may not support it.",
  "用 Google 登录": "Sign in with Google",
  "用 Google 登录 Gmail": "Sign in to Gmail with Google",
  "用 Google 登录（OAuth 授权）。": "Signed in with Google (OAuth).",
  "用{where}已登录的账号": "Using the account signed in {where}",
  "用户": "Users",
  "用户管理": "Users",
  "用户名": "Username",
  "用户名（一般就是邮箱地址）": "Username (usually your email address)",
  "用户名或找回邮箱": "Username or recovery email",
  "用哪个 AI": "Which AI to use",
  "用哪种：": "Use:",
  "用时 {s} 秒": "Took {s} s",
  "用新密码登录吧。所有设备上原来的登录都已经退出了，手机 App 也要重新登录一次。": "Sign in with your new password. You’ve been signed out on all devices, including the phone app.",
  "邮件操作": "Message actions",
  "邮件服务没能启动": "The mail service didn’t start",
  "邮件里的截止日期、会议时间可以用\"加入日历\"放进日历。连接 Google 日历后可以一键保存，回复会议邀请时也会顺便更新日历。": "Use \"Add to calendar\" to put deadlines and meeting times from messages into your calendar. With Google Calendar connected, it’s one click, and replying to meeting invitations updates your calendar too.",
  "邮件里提到的时间": "Times mentioned in the message",
  "邮件列表": "Message list",
  "邮件一直保存在邮箱（Gmail、QQ 等）里。馍馍邮箱的服务器会把邮件正文下载一份存着，打开时就不用再等邮箱。": "Your mail always stays in your mailbox (Gmail, QQ, etc.). The Momomail server keeps a downloaded copy of message bodies so opening them doesn’t have to wait for the mailbox.",
  "邮件已发出": "Message sent",
  "邮件由服务器一直在收，打开网页就能看。": "The server keeps fetching your mail; just open the page to read it.",
  "邮件由你自己的馍馍邮箱服务器收取和保存；这里用管理员给你开的账号登录。": "Your own Momomail server fetches and stores your mail. Sign in with the account your admin created for you.",
  "邮件正文：{subject}": "Message body: {subject}",
  "邮箱地址": "Email address",
  "邮箱服务器上的邮件不受影响": "Mail on the mail servers is not affected",
  "邮箱和文件夹": "Mailboxes and folders",
  "邮箱账户": "Email accounts",
  "有新邮件时会马上出现。": "New mail will show up here right away.",
  "有找回邮箱": "has recovery email",
  "语言": "Language",
  "阅读邮件": "Reading pane",
  "再次打开登录页": "Open sign-in page again",
  "再连接一个 Google 日历": "Connect another Google Calendar",
  "再试一次；一直不行请把详情发给管理员。": "Try again; if it keeps failing, send the details to your admin.",
  "再输一次": "Confirm password",
  "在 设置 → 日历 里连接 Google 日历后，可以一键保存。": "Connect Google Calendar in Settings → Calendar to save with one click.",
  "在 account.apple.com 的\"登录与安全 → App 专用密码\"里生成一个，填在这里。": "Create one at account.apple.com under \"Sign-In and Security → App-Specific Passwords\" and enter it here.",
  "在 Google 日历里查看": "View in Google Calendar",
  "在 Google 日历中打开": "Open in Google Calendar",
  "在 QQ 邮箱网页版\"设置 → 账号\"里开启 IMAP/SMTP 服务，按提示生成授权码，填在这里（不是 QQ 密码）。": "In QQ Mail on the web, enable IMAP/SMTP under \"Settings → Account\", generate an authorization code as prompted and enter it here (not your QQ password).",
  "在网页版\"设置 → POP3/SMTP/IMAP\"里开启 IMAP/SMTP 服务并设置客户端授权码。126、yeah.net 请把服务器里的 163 换成对应域名。": "On the web, enable IMAP/SMTP under \"Settings → POP3/SMTP/IMAP\" and set a client authorization code. For 126 or yeah.net, replace 163 in the server names with your domain.",
  "在新标签页里打开 Google 登录页，": "Open the Google sign-in page in a new tab,",
  "暂定": "Maybe",
  "暂停通知": "Pause notifications",
  "怎么获取{what}？": "How do I get a {what}?",
  "粘贴 API Key": "Paste API key",
  "粘贴代码": "Paste code",
  "账户": "Accounts",
  "账户名称": "Account name",
  "账户颜色": "Account color",
  "账户已更新": "Account updated",
  "找不到这个服务器地址": "Can't find this server address",
  "找回邮箱": "Recovery email",
  "找回邮箱已保存": "Recovery email saved",
  "这封邮件没有写主题，仍然发送吗？": "This message has no subject. Send it anyway?",
  "这个地址不是馍馍邮箱服务器": "That address isn't a Momomail server",
  "这个地址看起来不对：{address}": "This address doesn’t look right: {address}",
  "这个服务器不接受登录": "This server doesn't accept sign-ins",
  "这个活动已经取消了。": "This event has been cancelled.",
  "这个链接只能用一次。设好以后，所有设备上原来的登录都会退出。": "This link works only once. After you set a new password, you’ll be signed out on all devices.",
  "这个邀请用不了": "This invitation can’t be used",
  "这个账号已经停用": "This account has been disabled",
  "这里空空的": "Nothing here",
  "这是一封还没发出的草稿。": "This is a draft that hasn’t been sent.",
  "这台电脑上保存的邮件列表和打开过的邮件会删掉，然后从服务器重新同步。服务器上的数据不受影响。": "The message lists and opened messages stored on this computer will be deleted, then synced again from the server. Data on the server is not affected.",
  "这台电脑上的副本": "Copy on this computer",
  "这台电脑上的副本出问题时用。": "Use this if the copy on this computer has problems.",
  "这台设备会忘掉登录状态，服务器上的邮件和账户不受影响。": "This device will forget its sign-in. Mail and accounts on the server are not affected.",
  "这台设备会忘掉服务器的登录状态，服务器上的邮件和账户不受影响。": "This device will forget its sign-in to the server. Mail and accounts on the server are not affected.",
  "这台设备没有联网": "This device is offline",
  "正文": "Message body",
  "正文还没下载下来（可能离线了）。连上网络后再打开这封试试。": "The message body hasn’t been downloaded yet (you may be offline). Try opening it again once you’re connected.",
  "正在测试…": "Testing…",
  "正在从服务器重新同步": "Resyncing from the server",
  "正在从邮件里找时间…": "Looking for dates in the message…",
  "正在打开…": "Opening…",
  "正在打开邀请…": "Opening invitation…",
  "正在登录…": "Signing in…",
  "正在读取文件夹…": "Loading folders…",
  "正在服务器上标为已读…": "Marking as read on the server…",
  "正在后台下载 {version}": "Downloading {version} in the background",
  "正在后台下载 {version}（{percent}%）": "Downloading {version} in the background ({percent}%)",
  "正在回答…": "Answering…",
  "正在检查…": "Checking…",
  "正在连接邮件服务…": "Connecting to the mail service…",
  "正在收信…": "Checking mail…",
  "正在同步…": "Syncing…",
  "正在验证…": "Verifying…",
  "正在准备 Google 登录…": "Preparing Google sign-in…",
  "正在准备登录…": "Preparing sign-in…",
  "支持推送（IDLE）的邮箱会即时收到；这里是全部文件夹的定时检查。": "Mailboxes that support push (IDLE) get mail instantly; this is the scheduled check for all folders.",
  "只存在本机、还没上传的草稿": "Drafts saved only on this device, not uploaded yet",
  "只会从馍馍邮箱里移除这个账户和本机缓存的邮件，": "This only removes the account and its locally cached mail from Momomail — ",
  "只申请\"查看和修改日历活动\"的权限，不会读你的其他 Google 数据。": "Only asks for permission to \"view and edit calendar events\" and never reads your other Google data.",
  "只是不再从馍馍邮箱写这个日历，日历里已有的活动不受影响。": "Momomail will just stop writing to this calendar; existing events are not affected.",
  "只是这里不再使用，{where}系统里的登录 / Key 不受影响": "Only stops using it here; the sign-in / key {where} is not affected",
  "只说有几封新邮件": "Only the number of new messages",
  "重复": "Recurring",
  "重启更新": "Restart to update",
  "重试": "Retry",
  "重新加载": "Reload",
  "重新开始": "Start over",
  "重新连接": "Reconnect",
  "重新填写密码": "Re-enter password",
  "重新同步": "Resync",
  "重新用 Google 登录": "Sign in with Google again",
  "重置链接": "Reset link",
  "主题": "Subject",
  "注意大小写；忘了密码可以点\"忘记密码\"，或者找管理员。": "Passwords are case-sensitive. Forgot it? Use \"Forgot password\" or ask your admin.",
  "转发": "Forward",
  "组织者：{name}": "Organizer: {name}",
  "最大化": "Maximize",
  "最近 {n} 年": "Last {n} year(s)",
  "最近 {n} 天": "Last {n} days",
  "最小化": "Minimize",
  "昨天": "Yesterday",
  "AI 在服务器上运行，只回答文字：不能执行命令、不能读写文件。": "The AI runs on the server and only answers in text: it can’t run commands or read or write files.",
  "App 专用密码": "app-specific password",
  "Gmail 地址（可以不填，在 Google 页面上选）": "Gmail address (optional — you can choose on the Google page)",
  "Google 登录": "Google sign-in",
  "Google 登录最省事，但 Google 那边有变动时（改密码、撤销授权）要重新登录一次。": "Signing in with Google is easiest, but you will need to sign in again if something changes on Google’s side (password change, revoked access).",
  "Google 会提示\"此应用未经验证\"时，点\"高级\"→\"继续\"。这是你自己的服务器。": "If Google says \"This app isn’t verified\", click \"Advanced\" → \"Continue\". It’s your own server.",
  "Google OAuth 授权。需要重新授权时，在服务器上运行": "Google OAuth. To authorize again, run this on the server:",
  "iCloud 邮件": "iCloud Mail",
  "QQ 邮箱": "QQ Mail",
  "字体": "Font",
  "全部用馍馍字体": "Momo font everywhere",
  "界面用馍馍字体": "Momo font for the app",
  "全部用系统字体": "System font everywhere",
  "界面和邮件都用": "For the app and your mail",
  "邮件用系统字体（默认）": "System font for mail (default)",
  "邮件正文": "Mail text",
  "在服务器上更早的邮件里找": "Search older mail on the server",
  "改回本机模式？": "Switch back to local mode?",
  "这台电脑会退出服务器的登录，改用本机的邮件服务（本机原来的数据都还在）。": "This computer will sign out of the server and use the local mail service again (your local data is still there).",
  "账号与连接": "Account & connection",
  "本机模式": "Local mode",
  "邮件服务跑在这台电脑上，不用登录。也可以连接部署在自己服务器上的馍馍邮箱。": "The mail service runs on this computer; no sign-in needed. You can also connect to a Momomail server you host yourself.",
  "已登录为 {name}": "Signed in as {name}",
  "已连接服务器": "Connected to a server",
  "更换账户": "Switch account",
  "登录另一个账户": "Sign in to another account",
  "可以换一个用户名，也可以换一台服务器。登录成功后这台电脑就切换过去，原来的账户在服务器上不受影响。": "Use a different username or a different server. Once signed in, this computer switches over; the old account on the server is not affected.",
  "忘了密码时，重置链接发到 {email}": "If you forget your password, the reset link goes to {email}",
  "还没有设置：忘了密码时没法自己找回": "Not set: you can’t reset a forgotten password yourself",
  "修改": "Change",
  "请填一个你平时能收到信的邮箱。": "Use an address where you actually receive mail.",
  "{n} 个邮箱登录失效": "{n} mailbox(es) need you to sign in again",
  "Google 日历要重新连接": "Google Calendar needs reconnecting",
  "通知已暂停": "Notifications are paused",
  "有新版本": "A new version is available",
  "(无标题)": "(No title)",
  "+{n} 更多": "+{n} more",
  "App 专用密码（在 account.apple.com → 登录与安全 里生成）": "App-specific password (create one at account.apple.com → Sign-In and Security)",
  "App 密码（Fastmail 设置 → 密码与安全 里生成）": "App password (Fastmail Settings → Privacy & Security)",
  "Apple ID 邮箱": "Apple ID email",
  "Ctrl+Enter 保存": "Ctrl+Enter to save",
  "Fastmail 邮箱地址": "Fastmail address",
  "Google 日历会申请\"查看、编辑日历\"的权限，只用来显示和修改你的日程。以前连接过的需要重新登录一次。": "Google Calendar asks for permission to view and edit your calendars, used only to show and change your events. Calendars connected before need to sign in once more.",
  "QQ 邮箱地址": "QQ Mail address",
  "{ago}同步过": "Synced {ago}",
  "{name} 已同步": "{name} synced",
  "{name} 已重新登录": "{name} signed in again",
  "{n} 个日历账户要重新登录": "{n} calendar account(s) need signing in again",
  "上一页": "Previous",
  "上一页（←）": "Previous (←)",
  "上个月": "Previous month",
  "下一页": "Next",
  "下一页（→）": "Next (→)",
  "下个月": "Next month",
  "今天": "Today",
  "今天（T）": "Today (T)",
  "会从 {calendar} 里删掉，其他设备上也会消失。": "It will be deleted from {calendar} and disappear on your other devices too.",
  "先连接一个可以写入的日历": "Connect a calendar you can write to first",
  "先选一个日历": "Pick a calendar first",
  "其他 CalDAV / Nextcloud": "Other CalDAV / Nextcloud",
  "切换到日历": "Switch to calendar",
  "切换到邮件": "Switch to mail",
  "切换邮件和日历": "Switch between mail and calendar",
  "删除\"{title}\"？": "Delete \"{title}\"?",
  "只是不再在馍馍邮箱里显示这个账户的日历，{provider} 上的日历和活动不受影响。邮箱账户也不受影响。": "Momomail just stops showing this account's calendars; the calendars and events on {provider} stay as they are, and so do your mail accounts.",
  "只读": "Read-only",
  "同步": "Sync",
  "周": "Week",
  "在日历里显示 {name}": "Show {name} in the calendar",
  "密码或应用密码": "Password or app password",
  "已保存": "Saved",
  "已添加 {name}": "Added {name}",
  "已添加到日历": "Added to the calendar",
  "已移除": "Removed",
  "已隐藏": "Hidden",
  "换颜色": "Change color",
  "授权码（QQ 邮箱 → 设置 → 账号 里生成，不是 QQ 密码）": "Authorization code (QQ Mail → Settings → Account; not your QQ password)",
  "接下来两个月没有安排": "Nothing in the next two months",
  "接下来的日程": "Upcoming",
  "新建活动": "New event",
  "新建活动（N）": "New event (N)",
  "日历同步出错": "Calendar sync failed",
  "日历账户": "Calendar accounts",
  "日程": "Agenda",
  "显示 {name}": "Show {name}",
  "显示中": "Shown",
  "显示名称（可以不填）": "Display name (optional)",
  "月": "Month",
  "服务器没有配置 Google 登录，所以不能连接 Google 日历（请管理员按 deploy/README.md 配置）。CalDAV 日历照样能用。": "The server has no Google sign-in configured, so Google Calendar can't be connected (ask the admin to follow deploy/README.md). CalDAV calendars still work.",
  "正在第一次同步…": "Syncing for the first time…",
  "比如：和小王吃饭": "e.g. Lunch with Sam",
  "添加 CalDAV 日历": "Add a CalDAV calendar",
  "点空白处新建活动": "Click an empty spot to add an event",
  "移除": "Remove",
  "移除日历账户\"{name}\"？": "Remove the calendar account \"{name}\"?",
  "立即同步": "Sync now",
  "立即同步日历": "Sync calendars now",
  "管理日历账户": "Manage calendar accounts",
  "结束时间要晚于开始时间": "The end must be after the start",
  "编辑活动": "Edit event",
  "视图": "View",
  "还没有可以写入的日历。先在 设置 → 日历 里连接 Google 日历或 CalDAV 日历。": "No calendar you can write to yet. Connect Google Calendar or a CalDAV calendar in Settings → Calendar first.",
  "还没有连接日历": "No calendars connected yet",
  "这个日历是只读的。": "This calendar is read-only.",
  "这是重复的活动，暂时只能看。要修改请到原来的日历里改。": "This is a repeating event and is read-only for now. Change it in its original calendar.",
  "连接": "Connect",
  "连接 Google 日历或 CalDAV 日历（iCloud、QQ 邮箱、Fastmail、Nextcloud 等），所有日历合在「日历」页里一起看。日历账户和邮箱账户互不影响：同一个 Gmail 可以只当邮箱、只当日历，或者两样都用。": "Connect Google Calendar or CalDAV calendars (iCloud, QQ Mail, Fastmail, Nextcloud, …); all of them show together on the Calendar page. Calendar accounts are separate from mail accounts: the same Gmail can be used for mail only, calendar only, or both.",
  "连接 Google 日历或者 iCloud、QQ 邮箱等 CalDAV 日历，所有日历的活动会放在这里一起看。和邮箱账户互不影响。": "Connect Google Calendar or CalDAV calendars such as iCloud or QQ Mail, and all their events show up here together. Mail accounts are not affected.",
  "连接日历": "Connect a calendar",
  "选一个日历": "Choose a calendar",
  "邮件": "Mail",
  "重新登录": "Sign in again",
  "重新登录 {name}": "Sign in to {name} again",
  "隐藏 {name}": "Hide {name}",
  "隐藏的日历里的活动不会显示。": "Events in hidden calendars aren't shown.",
  "邮件标签": "Mail tags",
  "让 AI 给收件箱的每封新邮件打标签（工作、个人、广告……），并判断要不要马上告诉你：只有值得看的邮件才发通知，紧急的更醒目。第一次打开时会先给最近的 50 封打上。AI 只读邮件，不能做任何操作，也不会记住内容；这件事量大，建议选便宜、快的模型。": "Let an AI tag every new message in your inbox (work, personal, ads…) and decide whether you should hear about it now: only mail worth seeing sends a notification, and urgent mail stands out. The first time it's turned on, the latest 50 messages are tagged too. The AI only reads the mail — it can't do anything and doesn't remember it. It handles a lot of mail, so a cheap, fast model is a good choice.",
  "先在上面登录一个 AI 或填写 API Key。": "Sign in to an AI or enter an API key above first.",
  "不打标签": "Off",
  "便宜、快的模型就够用，比如 Claude Haiku、千问 Flash、DeepSeek Flash。": "A cheap, fast model is enough, such as Claude Haiku, Qwen Flash or DeepSeek Flash.",
  "和这个 AI 的设置一样（{model}）": "Same as this AI's setting ({model})",
  "广告和垃圾邮件移到垃圾箱": "Move ads and spam to the spam folder",
  "关着时只打标签。打开后，AI 认为是广告或垃圾的邮件会移到邮箱的垃圾邮件文件夹（Gmail 等网页上也一样），移错了可以移回来。": "When off, mail is only tagged. When on, what the AI considers ads or spam moves to your mailbox's spam folder (Gmail and other web mail see it there too); you can move anything back.",
  "已打标签 {n} 封（今天 {today} 封）": "{n} tagged ({today} today)",
  "还有 {n} 封在排队": "{n} waiting",
  "上次出错：{error}": "Last error: {error}",
  "个人": "Personal",
  "工作": "Work",
  "订单账单": "Orders & bills",
  "订阅": "Newsletter",
  "广告": "Ad",
  "垃圾": "Junk",
  "紧急": "Urgent",
  "待回复": "Reply",
  "AI 正在退订…": "AI is unsubscribing…",
  "AI 正在退订，可能要一分钟…": "AI is unsubscribing, this can take a minute…",
  "不想再收到这类邮件？": "Don't want mail like this anymore?",
  "发一封退订邮件？": "Send an unsubscribe email?",
  "发送退订邮件": "Send unsubscribe email",
  "已退订": "Unsubscribed",
  "已退订这个发件人": "Unsubscribed from this sender",
  "正在退订…": "Unsubscribing…",
  "这个发件人提供退订": "This sender offers an unsubscribe link",
  "这个发件人要求用邮件退订：会用你的邮箱给 {to} 发一封主题为\"{subject}\"的邮件。": "This sender unsubscribes by email: a message with the subject \"{subject}\" will be sent from your mailbox to {to}.",
  "退订": "Unsubscribe",
  "和邮件标签用同一个": "Same as mail tags",
  "点邮件里的\"退订\"时，需要在网页上操作的由 AI 在服务器上完成：它只能看网页、点链接、填表，不会登录或填写密码。": "When you tap \"Unsubscribe\" in a message and it has to be done on a web page, an AI does it on the server: it can only read the page, follow links and fill in forms — it never signs in or types passwords.",
  "退订网页用哪个 AI": "AI for unsubscribe pages",
  "不用了": "No thanks",
  "保存规则": "Save rules",
  "写给打标签的 AI 看，优先于它自己的判断。可以定义自己的标签，和\"紧急\"\"待回复\"等一起显示。也可以让馍馍帮你改。": "For the tagging AI to follow; they take precedence over its own judgment. You can define your own tags, shown alongside \"Urgent\", \"Reply\" and the rest. Momo can change them for you too.",
  "去设置": "Open settings",
  "和上面选中的一样": "Same as the one selected above",
  "和馍馍聊聊": "Chat with Momo",
  "喵～我是馍馍。让我帮你找邮件、写回复、整理收件箱、安排日程，或者改设置都行。比如：\"把这周没回的重要邮件列出来\"、\"帮我约王五下周二开会\"。": "Meow~ I'm Momo. I can find mail, write replies, tidy your inbox, plan your calendar or change settings. Try \"List the important mail I haven't answered this week\" or \"Set up a meeting with Wang next Tuesday\".",
  "在写草稿…": "Writing a draft…",
  "在准备发送…": "Getting it ready to send…",
  "在加日程…": "Adding an event…",
  "在找空闲时间…": "Looking for free time…",
  "在搜邮件…": "Searching mail…",
  "在改日程…": "Changing an event…",
  "在整理邮件…": "Tidying mail…",
  "在看日程…": "Checking the calendar…",
  "在看邮件列表…": "Looking at the mail list…",
  "在看附件…": "Reading an attachment…",
  "在记笔记…": "Taking notes…",
  "在读整个对话…": "Reading the conversation…",
  "在读邮件…": "Reading mail…",
  "已取消": "Cancelled",
  "已完成": "Done",
  "我的分类规则和标签": "My tagging rules and tags",
  "没有成功": "Didn't work",
  "清空对话": "Clear chat",
  "点右下角的馍馍就能和它聊天：找邮件、写回复、整理收件箱、安排日程、改设置。它在服务器上运行，只能用馍馍邮箱给它的工具；发邮件、删日程等会先问你。建议选聪明一点的模型。": "Tap Momo in the corner to chat: find mail, write replies, tidy the inbox, plan the calendar, change settings. It runs on the server and can only use the tools Momomail gives it; sending mail, deleting events and the like ask you first. A smarter model works best.",
  "确认": "Confirm",
  "请小助手帮忙…": "Asking a helper…",
  "跟馍馍说点什么…": "Say something to Momo…",
  "还没有记下任何东西": "Nothing remembered yet",
  "馍馍": "Momo",
  "馍馍从对话里记下的事，帮它了解你。可以直接修改或删掉不想让它记住的内容。": "What Momo has noted from your chats, to get to know you. Edit it freely or delete anything you don't want it to remember.",
  "馍馍助理": "Momo assistant",
  "馍馍在想…": "Momo is thinking…",
  "馍馍的记忆": "Momo's memory",
  "馍馍还没有可用的 AI。先在 设置 → AI 登录一个，再在\"馍馍助理\"里选它。": "Momo has no AI yet. Sign in to one in Settings → AI, then pick it under \"Momo assistant\".",
  "比如：": "For example:",
  "标签：工作、学习、家庭": "Tags: Work, Study, Family",
  "GitHub 上 momo/mail 仓库的 PR 通知都算垃圾邮件": "Pull request notifications from the momo/mail repo on GitHub are spam",
  "导师 zhang@school.edu 的邮件一律紧急": "Mail from my advisor zhang@school.edu is always urgent",
  "GitHub 上 momo/mail 仓库的 PR 通知都算垃圾": "Pull request notifications from the momo/mail repo on GitHub are junk",
  "一封邮件可以同时有好几个标签，和系统的\"重要\"\"待回复\"等一起显示。写上标签是干什么的，AI 会分得更准。": "A message can have several tags at once, shown alongside the system's \"Important\", \"Reply\" and the rest. Saying what a tag is for helps the AI sort better.",
  "什么样的邮件算这个（可选）": "What counts as this (optional)",
  "优先于它自己的判断。也可以让馍馍帮你改。": "They take precedence over its own judgment. Momo can change them for you too.",
  "保存标签": "Save tags",
  "关着时只打标签。打开后，AI 标为\"垃圾\"的邮件会移到邮箱的垃圾邮件文件夹（Gmail 等网页上也一样），移错了可以移回来。": "When off, mail is only tagged. When on, mail the AI marks as \"Junk\" moves to your mailbox's spam folder (Gmail and other web mail see it there too); you can move anything back.",
  "删除标签": "Delete tag",
  "垃圾邮件移到垃圾箱": "Move junk to the spam folder",
  "学校教务处的邮件都打上\"学习\"": "Tag everything from the school registrar \"Study\"",
  "导师 zhang@school.edu 的邮件一律重要": "Mail from my advisor zhang@school.edu is always important",
  "我的标签": "My tags",
  "按现在的标签和规则重新打最近 50 封": "Re-tag the latest 50 with the current tags and instructions",
  "新标签，比如：学习": "New tag, e.g. Study",
  "添加": "Add",
  "给打标签 AI 的额外说明": "Extra instructions for the tagging AI",
  "重要": "Important",
  "馍馍自己记下的事，帮它了解你，它会随时整理。想让它忘掉什么，直接在对话里告诉它。": "What Momo has noted to get to know you; it keeps the notes tidy itself. To make it forget something, just tell it in the chat.",
  "标签已更新": "Tags updated",
  "在做文件…": "Making a file…",
  "桌面小猫": "Desktop cat",
  "馍馍在桌面和窗口上走来走去，新邮件用对话泡泡告诉你；点它有快捷操作，按住可以拎起来。关掉后通知换回弹窗。（只对这台电脑生效）": "Momo walks around your desktop and windows and tells you about new mail with a speech bubble. Click it for shortcuts, press and hold to pick it up. Turned off, notifications go back to the popup. (This computer only)",
  "全部移到垃圾邮件？": "Move all to spam?",
  "AI 标为\"垃圾\"的 {n} 封邮件会移到各自邮箱的垃圾邮件文件夹（Gmail 等网页上也一样）。移错了可以从垃圾邮件里移回来。": "The {n} emails the AI tagged as junk will move to the spam folder of their mailbox (on Gmail and other web mail too). Anything moved by mistake can be moved back from spam.",
  "移到垃圾邮件": "Move to spam",
  "移走了 {n} 封": "Moved {n}",
  "AI 标签": "AI tags",
  "AI 给新邮件打上这个标签后，会出现在这里。": "Mail shows up here once the AI tags it with this.",
  "AI 认为这些是垃圾邮件。": "The AI thinks these are junk.",
  "全部移到垃圾邮件": "Move all to spam",
  "不重要": "Low priority",
  "以前的对话": "Earlier chats",
  "删除这段对话": "Delete this chat",
  "新对话": "New chat",
  "更早": "Earlier",
  "这周": "This week",
  "还没有以前的对话。聊完一段时间不说话，或者点\"新对话\"，这段就会收到这里。": "No earlier chats yet. A chat goes here after it has been quiet for a while, or when you start a new one.",
  "搜索结果：{query}": "Search results: {query}",
  "在看屏幕…": "Looking at the screen…",
  "在操作屏幕…": "Working the screen…",
  "在打开页面…": "Opening a page…",
  "在看页面…": "Looking at a page…",
  "搜邮件": "Searched mail",
  "看邮件列表": "Looked at the mail list",
  "读邮件": "Read a mail",
  "读整个对话": "Read the whole conversation",
  "看附件": "Looked at an attachment",
  "做文件": "Made a file",
  "整理邮件": "Tidied mail",
  "写草稿": "Wrote a draft",
  "准备发送": "Got an email ready",
  "看日程": "Looked at the calendar",
  "找空闲时间": "Looked for free time",
  "加日程": "Added an event",
  "改日程": "Changed an event",
  "请小助手帮忙": "Asked a helper",
  "记笔记": "Took notes",
  "找联系人": "Looked up contacts",
  "看文件夹": "Looked at folders",
  "准备打开": "Got a page ready",
  "看设置": "Read the settings",
  "改设置": "Changed settings",
  "看分类规则": "Read the tagging rules",
  "改分类规则": "Changed the tagging rules",
  "看屏幕": "Looked at the screen",
  "操作屏幕": "Worked the screen",
  "打开页面": "Opened a page",
  "看页面": "Looked at a page",
  "用了一个工具": "Used a tool",
  "做了 {n} 步": "{n} steps",
  "{s} 秒": "{s} s",
  "停止": "Stop",
  "已加入日历：{title}": "Added to calendar: {title}",
  "日历里已经有了": "Already in your calendar",
  "已加入日历": "Added to calendar",
  "在网页上退订好了吗？": "Done unsubscribing on the page?",
  "退订页面已在浏览器里打开。在那里退订完以后点\"已退订\"，这个发件人的退订按钮就不再出现。": "The unsubscribe page is open in your browser. Once you have unsubscribed there, press \"Unsubscribed\" and the unsubscribe button won't show for this sender again.",
  "让馍馍「{name}」吗？": "Let Momo \"{name}\"?",
  "这一步没法轻易撤销，馍馍想先问问你。": "This step can't easily be undone, so Momo wants to check with you first.",
  "好的": "OK",
  "不要": "No",
  "馍馍正在操作…": "Momo is working…",
  "馍馍正在操作，做完再聊": "Momo is working — chat when it is done"
}
